import { ProductsService } from "./products.service";
import type { IProductsService } from "./products.service.interface";

export const productsService: IProductsService = new ProductsService();
